<script setup lang="ts">
import { RouterView } from 'vue-router';
import PwaInstallPrompt from '@/components/PwaInstallPrompt.vue';
import './index.css';
</script>

<template>
  <RouterView />
  <PwaInstallPrompt />
</template>
